import { Component } from '@angular/core';

@Component({
  templateUrl: './bending-machine-shell.component.html'
})
export class BendingMachineShellComponent {}
